import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=6001b548&scoped=true&"
import script from "./UploadIcon.vue?vue&type=script&lang=js&"
export * from "./UploadIcon.vue?vue&type=script&lang=js&"
import style0 from "./UploadIcon.vue?vue&type=style&index=0&id=6001b548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6001b548",
  null
  
)

export default component.exports